import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "has-text-centered box"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_images_carousel = _resolveComponent("images-carousel")!

  return (_ctx.images?.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_images_carousel, {
          images: _ctx.images,
          initialIndex: _ctx.currentSlide,
          withThumbnails: true,
          onImageClick: _ctx.openFullscreenSlider
        }, null, 8, ["images", "initialIndex", "onImageClick"]),
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "is-size-7" }, "Click an image for fullscreen mode", -1))
      ]))
    : _createCommentVNode("", true)
}